<template>
  <div class="news">
    <Header
      v-bind:header="header"
      class="pb-16 pb-xl-0 pb-lg-0 pb-md-0 pd-sm-0"
    ></Header>

    <div class="notecontainer">
      <NoteCircle v-bind:config="noteCircle1"></NoteCircle>
    </div>

    <div>
      <v-container class="non_bg pb-10">
        <v-row class="justify-end">
          <v-col :cols="12" xl="8" lg="8" md="8" sm="10">
            <ScriptTile v-bind:script="script"></ScriptTile>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="pb-16">
      <v-container class="dark_bg noverflow_ma top_space_news">
        <div class="">
          <NewsCarousel></NewsCarousel>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import Header from "./Header.vue";
// import QuoteTile from './QuoteTile.vue'
import NewsCarousel from "./NewsCarousel.vue";
import ScriptTile from "./ScriptTile.vue";
import NoteCircle from "./NoteCircle.vue";

export default {
  name: "Staff",
  components: {
    Header,
    // QuoteTile,
    NewsCarousel,
    ScriptTile,
    NoteCircle,
  },
  data() {
    return {
      header: "Neues",
      noteCircle1: {
        id: "news_c1",
        width: 950,
        top: -100,
        left: 550,
        style: "stroke-dasharray: 0.5;",
        strokeWidth: 4,
        transform:
          "rotateZ(calc(var(--parallax-value) * 0.7deg))",
        minLimit: 0,
        maxLimit: 3000,
      },
      // quote: {
      //   quoteLines: [
      //       {
      //           id: 1,
      //           text: "“Noch mal vielen Dank für den bejazzten Konzertabend im Schloss Reinbek. Das hat große Freude gemacht, die ganzen Nummern zu hören. Ich mag auch Spain und Birdland so doll gerne.”"
      //       }
      //   ],
      //   author: "Zuschauer-Stimme",
      //   withImage: false,
      //   img: {
      //     url: "/news/halle.jpeg",
      //     alt: "Halle 424"
      //   }
      // },
      script: {
        title: "Motiv 16: Nica 1947",
        scriptFill1:
          "15. Oktober 1957, um die Mittagszeit. Ein grauer Tag, irgendwo in Maryland. Ein Streifenwagen hält eine Luxuslimousine an, mit New Yorker Kennzeichen. Am Steuer eine Lady im Pelzmantel, auf dem Beifahrersitz wie angewurzelt ein großer schwarzer Mann.",
        scriptFill2:
          "Ihr Mann ist Diplomat, lebt in Mexiko, aber sie ist ihm davongeflattert. Kein Wunder, ihr Spitzname ist Pannonica und bezeichnet einen Nachtfalter. Den hat ihr der Vater verpasst. Pannonica also, Nica de Koenigswater, geborene Rothschild. Im zweiten Weltkrieg hat sie Jeeps gefahren und einen Lancasterbomber geflogen, in Nordafrika. Gegen die Nazis gekämpft. Und jetzt gegen Ignoranz. Und Rassentrennung. Sie hat schon so manchem aus der Patsche geholfen. Die Jazzbaroness.",
        lines: [
          {
            id: 1,
            speaker: "Nancy",
            text: "Walter? Was ist denn da oben?",
          },
          {
            id: 2,
            speaker: "Walter",
            text:
              "Wollte nur schauen, ob’s stimmt, was Miles Davis gesagt hat: „Was wir gemeinsam gespielt haben, das muss irgendwo in der Luft schweben, denn dorthin haben wir’s geblasen.",
          },
        ],
      },
      // quote: {
      //   quoteLines: [
      //     {
      //       id: 1,
      //       speaker: "Dawn",
      //       text: "Mann, schau dich um! Die Menschen, die Autos, das Leben ... der Sound von New York! Wenn die Melodie unter dem Bogen am Washington Square hindurch fliegt und über die Felsen im Central Park hüpft – wie ein frecher Gedanke. Jazz ist das, was dir gerade in den Sinn kommt! Nicht das, was die andere hören wollen."
      //     },
      //     {
      //       id: 2,
      //       speaker: "FRANCIS",
      //       text: "Klingt, als sei das dein Lebensmotto."
      //     },
      //   ],
      //   withImage: false
      // }
    };
  },
};
</script>
<style lang="scss" scoped>
@import "~vuetify/src/styles/settings/_variables.scss";

.top_space_news {
  padding-top: 3rem;

  @media #{map-get($display-breakpoints, 'sm-and-up')} {
    padding-top: 10rem;
  }
}
.noverflow_ma {
  margin-bottom: 250px;
  padding-right: 0px;
  padding-left: 0px;
}

.notecontainer {
  position: relative;
}
</style>